import { render } from "./MobileUserNavigation.vue?vue&type=template&id=5899324f"
import script from "./MobileUserNavigation.vue?vue&type=script&lang=js"
export * from "./MobileUserNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__